import React, { useContext, useState } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";

const FAQ = () => {
  return (
    <div className={container}>
      <h2>FAQ</h2>
      <section>
        <h4>What counts as a view/month?</h4>
        <p>A view is counted any time the widget is loaded into a page.</p>
        <p>This will be tracked for a single user each time they hit the page, so be certain to only include the embed code in the head of pages you want your spotlight displayed and tracked.</p>
      </section>

      <section>
        <h4>When will I be charged?</h4>
        <p>If we don't have a card on file already, you will be taken to a screen to add your card. After that, you'll be charged immediately for the new plan amount.</p>
        <p>Otherwise, you'll be upgraded/downgraded and then prorated for the rest of your current billing cycle.</p>
      </section>

      <section>
        <h4>What is weekly reporting?</h4>
        <p>You will receive a custom email every week with the performance of your live spotlight. This includes views, clicks, starts, finishes, etc.</p>
      </section>
    </div>
  );
};

export default FAQ;

const container = css`
  display: none;
  flex: 1;
  padding: 10px 0 10px 40px;
  flex-direction: column;
  letter-spacing: 1px;
  max-height: 850px;
  overflow-y: scroll;
  
  section {
    margin-top: 25px;
   
    h4 {
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 15px;
    }
   
    p {
      margin-bottom: 20px;
      font-weight: 400;
      color: ${colors.subtitleColor};
      letter-spacing: .5px;
      font-size: 14px;
      line-height: 24px;
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    display: flex;
  }
`;
